import { render, staticRenderFns } from "./BackupProductsStep.vue?vue&type=template&id=fe8a9b00&scoped=true&"
import script from "./BackupProductsStep.vue?vue&type=script&lang=ts&"
export * from "./BackupProductsStep.vue?vue&type=script&lang=ts&"
import style0 from "./BackupProductsStep.vue?vue&type=style&index=0&id=fe8a9b00&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8a9b00",
  null
  
)

export default component.exports